export interface Site {
  id: string;
  name: string;
  viewUrl: string;
  thumbnail: string;
}
